import { Redirect, Route } from 'react-router-dom';
import { observer } from 'mobx-react';
import auth from '../../store/auth.js'
import UnauthorizedLayout from '../../layouts/unauthorized-layout/unauthorized-layout.jsx';
import InitialLayout from '../../layouts/initial-layout/initial-layout';

const AnonRoute = observer(({ ...params }) => {
    const isLoggedIn = auth.isLoggedIn;
    const isInitializing = auth.isInitializing;
    const { component, ...other } = params;
    let InnerComponent = component;
    return (
        <Route {...other} render={
            () => {
                if (isInitializing) {
                    return (
                        <InitialLayout />
                    )
                } else {
                    if (!isLoggedIn && !isInitializing) {
                        return (
                            <UnauthorizedLayout>
                                <InnerComponent />
                            </UnauthorizedLayout>
                        )
                    } else {
                        return (
                            <Redirect to="/feed" />
                        )
                    }
                }
            }
        }
        />
    )
});

export default AnonRoute;